<template>
    <div class="hs">
			<img :src='logo2'>
		</div>	
</template>
<script>
export default {
    data() {
        return {
            logo2:require('../assets/images/logo2.png')
        }
    }
}
</script>
<style lang="less" scoped>
	.hs{
		width:100vw;
		height: 0.8rem;
		
		display:flex;
		align-items: center;
		justify-content: center;
		background:rgba(247,247,247,1);

		img{
			width: 0.7rem;
		}
	}
</style>
